/**
 * v1 in-app feedback capture — category/status option lists.
 * Mirrors the `check` constraints on `app_feedback.category` / `.status`
 * (migration `20260702000000_add_app_feedback.sql`).
 */
export const FEEDBACK_CATEGORY_OPTIONS = [
    { key: 'bug', label: 'Bug' },
    { key: 'idea', label: 'Idea' },
    { key: 'question', label: 'Question' },
    { key: 'other', label: 'Other' },
];
export const FEEDBACK_STATUS_OPTIONS = [
    { key: 'new', label: 'New' },
    { key: 'triaged', label: 'Triaged' },
    { key: 'closed', label: 'Closed' },
];
//# sourceMappingURL=feedback.js.map